export const CHAT_MENU_ICONS = ["search", "clip", "headphone-alt", "video-camera"];

export const CALL_DATA = [
  {
    imageNumber: 4,
    name: "Erica Hughes",
    icon: <i className="fa fa-share font-success"></i>,
    date: "5 May, 4:40 PM",
  },
  {
    imageNumber: 1,
    name: "Vincent Porter",
    icon: <i className="fa fa-reply font-danger"></i>,
    date: "5 May, 5:30 PM",
  },
  {
    imageNumber: 8,
    name: "Kori Thomas",
    icon: <i className="fa fa-reply font-danger"></i>,
    date: "1 Feb, 6:56 PM",
  },
  {
    imageNumber: 2,
    name: "Aiden Chavez",
    icon: <i className="fa fa-reply font-danger"></i>,
    date: "3 June, 1:22 PM",
  },
  {
    imageNumber: 4,
    name: "Erica Hughes",
    icon: <i className="fa fa-share font-success"></i>,
    date: "5 May, 4:40 PM",
  },
  {
    imageNumber: 1,
    name: "Vincent Porter",
    icon: <i className="fa fa-share font-success"></i>,
    date: "5 May, 5:30 PM",
  },
  {
    imageNumber: 8,
    name: "Kori Thomas",
    icon: <i className="fa fa-share font-danger"></i>,
    date: "1 Feb, 6:56 PM",
  },
  {
    imageNumber: 4,
    name: "Erica Hughes",
    icon: <i className="fa fa-share font-success"></i>,
    date: "5 May, 4:40 PM",
  },
];

export const SOCIAL_MEDIA_ICON = [
  { link: "https://www.facebook.com/login/", icon: "fa-facebook" },
  { link: "https://myaccount.google.com/", icon: "fa-google-plus" },
  { link: "https://twitter.com/i/flow/login", icon: "fa-twitter" },
  { link: "https://www.instagram.com/accounts/login/", icon: "fa-instagram" },
  { link: "https://rss.app/signin", icon: "fa-rss" },
];
